export function AppContentPage() {
  return (
    <>
      <h1 style={{ fontSize: 32, color: 'var(--primary)', marginBottom: 8 }}>App Content</h1>
      <p style={{ color: 'var(--text-muted)', maxWidth: 640, marginBottom: 24 }}>
        Lesson CMS for the GLP-1 mobile app. Tracks: Onboarding, Nutrition, Side
        effects, Movement, Plateaus, Maintenance. Status per lesson (published/draft/outline).
      </p>
      <div style={{ padding: 24, background: 'var(--card)', borderRadius: 14, border: '1px solid var(--line-soft)' }}>
        <p style={{ color: 'var(--text-muted)' }}>Stub — wires to app_lessons table once schema is applied.</p>
      </div>
    </>
  );
}
